import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import f1 from '../assets/images/testing.jpeg';
import f2 from '../assets/images/amc.jpeg';
import f3 from '../assets/images/installation.jpeg';
import f4 from '../assets/images/services.jpeg';
import headerImg from "../assets/images/header.png";

import { 
  FaBolt, 
  FaTools, 
  FaClipboardCheck, 
  FaShieldAlt,
  FaFileAlt,
  FaHome,
  FaCalendarAlt
} from "react-icons/fa";

const Services = () => {
  const categories = [
    {
      title: "Testing & Commissioning",
      icon: <FaClipboardCheck />,
      color: "#0054a6",
      image: f1,
      services: [
        "Testing & Calibration of Protective Relays",
        "Testing of Power & Distribution Transformers",
        "Testing & Filtration of Transformer Oil",
        "Testing & Commissioning of HT & LT Panels",
        "Testing of HT Cables",
        "High Voltage (Hi-Pot) Testing of HT Cables",
        "Motor Testing – HT & LT",
        "UPS Testing",
        "Servo Stabilizer Testing",
        "Thermography Testing",
        "Earth Pit / Earthing System Testing"
      ],
    },
    {
      title: "Installation & Retrofitting",
      icon: <FaTools />,
      color: "#e42525",
      image: f2,
      services: [
        "Electrical Breakdown Works",
        "Retrofitting of HT & LT Panels",
        "Erection of Panels and Electrical Equipment",
        "Cable Laying and Termination"
      ],
    },
    {
      title: "Engineering & Consultancy",
      icon: <FaFileAlt />,
      color: "#FFC020",
      image: f3,
      services: [
        "Consultancy for Electrical Installations",
        "Electrical Drawing Preparation & Approvals",
        "Detailed Engineering Jobs",
        "Energy Audits and Power Utilization Studies"
      ],
    },
    {
      title: "Supply & Maintenance",
      icon: <FaHome />,
      color: "#0a1a2d",
      image: f4,
      services: [
        "Supply of Protective Relays and Tailor-Made Panels",
        "Annual Maintenance Contracts (AMC)"
      ],
    },
  ];

  return (
    <>
<section id="services" style={{ padding: "70px 0 30px", background: "#fff" }}>
  <Container>

    <div className="section-header">

      <div className="section-eyebrow">
        OUR SERVICES
      </div>

      <h2 className="section-title">
        Electrical Testing & Engineering Services
      </h2>

      <p className="section-subtitle">
        Testing, commissioning, installation and maintenance services
        for industrial electrical systems.
      </p>

    </div>

  </Container>
</section>

      <div className="services-section">
        <Container>
          {/* Header Section */}
          


          {/* Services Grid */}
          <Row className="g-4">
            {categories.map((category, index) => (
              <Col lg={6} key={index} className="mb-4">
                <Card className="service-card border-0 h-100">
                  {/* Card Image */}
                  <div className="card-image-container">
                    <img 
                      src={category.image}
                      alt={category.title}
                      className="card-image"
                      loading="lazy"
                    />
                    <div className="image-overlay" style={{ backgroundColor: `${category.color}40` }}>
                      <div className="category-icon" style={{ backgroundColor: category.color }}>
                        {category.icon}
                      </div>
                    </div>
                  </div>

                  <Card.Body className="p-4">
                    {/* Category Title */}
                    <h4 className="mb-3" style={{ color: category.color }}>
                      {category.title}
                    </h4>

                    {/* Services List */}
                    <div className="services-list">
                      {category.services.map((service, idx) => (
                        <div key={idx} className="service-item d-flex align-items-start mb-2">
                          <div className="bullet me-2" style={{ backgroundColor: category.color }}></div>
                          <span className="service-text">{service}</span>
                        </div>
                      ))}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

        </Container>
      </div>

      {/* ALL CSS STYLES IN ONE PLACE */}
      <style jsx>{`
      /* ===== SIMPLE SERVICES HEADER ===== */

.services-simple-header {
  background: #ffffff;
  padding: 70px 0 30px;
  text-align: center;
}

.services-simple-header h2 {
  font-size: 28px;
  font-weight: 700;
  color: #d32f2f;
  margin-bottom: 8px;
}

.services-simple-header p {
  color: #555;
  font-size: 0.95rem;
  margin-bottom: 0;
}
        /* Main Section */
        .services-section {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  padding: 40px 0 80px;
}

        .services-section::before {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          width: 300px;
          height: 300px;
          background: radial-gradient(circle, rgba(0, 84, 166, 0.1) 1px, transparent 1px);
          background-size: 20px 20px;
          opacity: 0.5;
        }

        /* Header Styles */
        .header-line {
          width: 80px;
          height: 4px;
          background: linear-gradient(135deg, #e42525, #ff4757);
          margin: 0 auto 1.5rem;
          border-radius: 2px;
        }

        h1 {
          color: #0a1a2d;
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 1rem;
          letter-spacing: -0.5px;
        }

        .subtitle {
          color: #0054a6;
          font-size: 1.1rem;
          max-width: 600px;
          margin: 0 auto;
          line-height: 1.6;
          font-weight: 500;
        }

        /* Service Card Styles */
        .service-card {
          background: #ffffff;
          border-radius: 15px;
          transition: all 0.3s ease;
          box-shadow: 0 8px 25px rgba(0, 84, 166, 0.08);
          height: 100%;
          overflow: hidden;
          border: 1px solid rgba(0, 84, 166, 0.08);
        }

        .service-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 15px 35px rgba(0, 84, 166, 0.15);
        }

        /* Image Container */
        .card-image-container {
          position: relative;
          height: 220px;
          overflow: hidden;
        }

        .card-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s ease;
        }

        .service-card:hover .card-image {
          transform: scale(1.08);
        }

        .image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.4));
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .service-card:hover .image-overlay {
          opacity: 1;
        }

        .category-icon {
          width: 70px;
          height: 70px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 1.8rem;
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
          transform: scale(0.9);
          transition: transform 0.3s ease;
        }

        .service-card:hover .category-icon {
          transform: scale(1);
        }

        /* Services List Styles */
        .services-list {
          margin-top: 0.5rem;
        }

        .service-item {
          padding: 0.6rem 0;
          border-bottom: 1px solid rgba(0, 0, 0, 0.05);
          transition: all 0.2s ease;
        }

        .service-item:hover {
          background: rgba(0, 84, 166, 0.02);
          padding-left: 5px;
        }

        .service-item:last-child {
          border-bottom: none;
        }

        .bullet {
          width: 7px;
          height: 7px;
          border-radius: 50%;
          margin-top: 0.55rem;
          flex-shrink: 0;
          transition: transform 0.2s ease;
        }

        .service-item:hover .bullet {
          transform: scale(1.3);
        }

        .service-text {
          font-size: 0.95rem;
          color: #333;
          line-height: 1.5;
          font-weight: 500;
        }

        /* Additional Info Section */
        .additional-info {
          padding: 2.5rem;
          background: linear-gradient(135deg, #ffffff, #f8f9fa);
          border-radius: 15px;
          box-shadow: 0 5px 20px rgba(0, 84, 166, 0.1);
          border: 1px solid rgba(0, 84, 166, 0.1);
        }

        .additional-info h3 {
          color: #0a1a2d;
          font-weight: 700;
          font-size: 1.8rem;
        }

        .feature-card {
          background: white;
          border-radius: 12px;
          text-align: center;
          transition: all 0.3s ease;
          border: 1px solid rgba(0, 84, 166, 0.1);
          height: 100%;
        }

        .feature-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(0, 84, 166, 0.1);
        }

        .feature-icon {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: linear-gradient(135deg, #0054a6, #0066cc);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 1.5rem;
          margin: 0 auto;
        }

        .feature-card h5 {
          color: #0054a6;
          font-weight: 600;
          margin-bottom: 0.75rem;
        }

        .feature-card p {
          color: #555;
          font-size: 0.9rem;
          line-height: 1.5;
        }

        /* ============ RESPONSIVE STYLES ============ */

        /* Large Desktop */
        @media (min-width: 1400px) {
          .card-image-container {
            height: 250px;
          }
        }

        /* Desktop */
        @media (max-width: 1200px) {
          .card-image-container {
            height: 200px;
          }
          
          .category-icon {
            width: 65px;
            height: 65px;
            font-size: 1.6rem;
          }
        }

        /* Tablet */
        @media (max-width: 992px) {
          .services-section {
            padding: 4rem 0;
          }

          h1 {
            font-size: 2.2rem;
          }

          .subtitle {
            font-size: 1.05rem;
            padding: 0 1rem;
          }

          .card-image-container {
            height: 180px;
          }

          .category-icon {
            width: 60px;
            height: 60px;
            font-size: 1.4rem;
          }
        }

        /* Small Tablet */
        @media (max-width: 768px) {
          .services-section {
            padding: 3.5rem 0;
          }

          h1 {
            font-size: 1.9rem;
          }

          .subtitle {
            font-size: 1rem;
          }

          .card-image-container {
            height: 170px;
          }

          .service-card {
            margin-bottom: 1.5rem;
          }

          .category-icon {
            width: 55px;
            height: 55px;
            font-size: 1.3rem;
          }

          .additional-info {
            padding: 2rem;
          }

          .feature-card {
            padding: 1.5rem;
          }
        }

        /* Mobile */
        @media (max-width: 576px) {
          .services-section {
            padding: 3rem 0;
          }

          h1 {
            font-size: 1.7rem;
          }

          .subtitle {
            font-size: 0.95rem;
            padding: 0 1.5rem;
          }

          .card-image-container {
            height: 160px;
          }

          .card-body {
            padding: 1.5rem !important;
          }

          h4 {
            font-size: 1.3rem;
          }

          .service-text {
            font-size: 0.9rem;
          }

          .bullet {
            width: 6px;
            height: 6px;
            margin-top: 0.45rem;
          }

          .additional-info {
            padding: 1.5rem;
          }

          .additional-info h3 {
            font-size: 1.5rem;
          }

          .feature-icon {
            width: 50px;
            height: 50px;
            font-size: 1.3rem;
          }

          .feature-card h5 {
            font-size: 1rem;
          }

          .feature-card p {
            font-size: 0.85rem;
          }
        }

        /* Small Mobile */
        @media (max-width: 400px) {
          .services-section {
            padding: 2.5rem 0;
          }

          h1 {
            font-size: 1.5rem;
          }

          .subtitle {
            font-size: 0.9rem;
          }

          .card-image-container {
            height: 150px;
          }

          .category-icon {
            width: 50px;
            height: 50px;
            font-size: 1.2rem;
          }

          h4 {
            font-size: 1.2rem;
          }

          .service-text {
            font-size: 0.85rem;
          }

          .bullet {
            width: 5px;
            height: 5px;
            margin-top: 0.4rem;
          }

          .additional-info {
            padding: 1.25rem;
          }

          .feature-card {
            padding: 1.25rem;
          }
        }

        /* Extra Small Mobile */
        @media (max-width: 350px) {
          .services-section {
            padding: 2rem 0;
          }

          h1 {
            font-size: 1.4rem;
          }

          .card-image-container {
            height: 140px;
          }

          .category-icon {
            width: 45px;
            height: 45px;
            font-size: 1.1rem;
          }

          .service-text {
            font-size: 0.82rem;
          }
        }
      `}</style>
    </>
  );
};

export default Services;